/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientInstanceId } from '../../models/client-instance-id';
import { KeyType } from '../../models/key-type';

export interface DeleteCheckinArticleLock$Params {
  organizationSiteKey: KeyType;
  checkinKey: string;
  articleKey: KeyType;
  clientId: ClientInstanceId;
}

export function deleteCheckinArticleLock(http: HttpClient, rootUrl: string, params: DeleteCheckinArticleLock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteCheckinArticleLock.PATH, 'delete');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('checkinKey', params.checkinKey, {});
    rb.path('articleKey', params.articleKey, {});
    rb.query('clientId', params.clientId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteCheckinArticleLock.PATH = '/organization-sites/{organizationSiteKey}/consignee/checkins/{checkinKey}/article-locks/{articleKey}';
